import { ordersTypes } from '../types';

const initialState = {
    loading: true,
    orders: null,
    error: null,
    id: null,
    order: null,
    totalItems: null,
    currentPage: null,
};

export const orders = (state = initialState, action) => {
    switch (action.type) {
        case ordersTypes.GET_DATA_REQUEST:
            return { ...state, loading: true };
        case ordersTypes.GET_DATA_SUCCESS:
            return { ...state, loading: false, ...action.payload };
        case ordersTypes.GET_DATA_FAIL:
            return { ...state, loading: false, orders: null, error: action.error };

        case ordersTypes.GET_ORDER_REQUEST:
            return { ...state, loading: true, id: action.id };
        case ordersTypes.GET_ORDER_SUCCESS:
            return { ...state, loading: false, order: action.order };
        case ordersTypes.GET_ORDER_FAIL:
            return { ...state, loading: false, order: null, error: action.error };
        case ordersTypes.CLEAR:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};
